module.exports = __webpack_public_path__ + "static/img/banner-化工行业智能监管解决方案.16afae16.webp";